import * as React from 'react';
import {Link} from 'react-router-dom';
import {
  List,
  ListItem
} from '../../list';
import * as routes from '../../../util/routes';

export default class PPIListComponent extends React.Component {
  render() {
    return (
      <div>
        <p><Link to={routes.INSTRUCTIONS_ADD}>Ajouter un ppi</Link></p>
          <List loading={this.props.loading} loadingText="Chargement des ppis...">
            {(!this.props.loading && this.props.ppis)
              && 0 === this.props.ppis.length
                ? <ListItem secondaryText="Aucun ppi" />
                : this.props.ppis.map(ppi => (
                  <ListItem
                    id={`nomeclature-${ppi.id}`} 
                    key={ppi.id} 
                    primaryText={ppi.name}
                    route={`${routes.INSTRUCTIONS}/${ppi.id}`} />))}
          </List>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-list/ppi-list-component.js